import { render, staticRenderFns } from "./CreateObject.vue?vue&type=template&id=27a087c0&scoped=true"
import script from "./CreateObject.vue?vue&type=script&lang=js"
export * from "./CreateObject.vue?vue&type=script&lang=js"
import style0 from "./CreateObject.vue?vue&type=style&index=0&id=27a087c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a087c0",
  null
  
)

export default component.exports